import { render, staticRenderFns } from "./PrBookingList.vue?vue&type=template&id=ed9b3f2e&scoped=true&"
import script from "./PrBookingList.vue?vue&type=script&lang=js&"
export * from "./PrBookingList.vue?vue&type=script&lang=js&"
import style0 from "./PrBookingList.vue?vue&type=style&index=0&id=ed9b3f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9b3f2e",
  null
  
)

export default component.exports